<template>
    <UiModal
        :is-open="isOpen"
        :title="`You have ${unmatchCount} card${unmatchCount > 1 ? 's' : ''} to match.`"
        icon="caution"
        icon-color="orange"
        width="600px"
        @close="$emit('close')"
    >
        <template #content>
            <div class="text-center pt-8">
                <p class="text-lg max-w-lg mx-auto mb-5">
                    We need your help identifying which
                    {{ unmatchCount > 1 ? 'cards these are' : 'card this is' }}
                    in order for you to get the most out of My10x.
                </p>
            </div>
        </template>

        <template #footer>
            <div class="flex justify-between w-full p-4 gap-3 items-stretch">
                <button
                    type="button"
                    @click="close()"
                    class="btn-base btn-dark flex-1"
                    id="hs-wallet-close-unmatched-modal"
                >
                    Close
                </button>
                <button
                    type="button"
                    class="btn-base btn-white flex-1 whitespace-nowrap"
                    @click="illDoLater()"
                    id="hs-wallet-close-acknowledge-unmatched-cards"
                >
                    I know, I'll do it later
                </button>
            </div>
        </template>
    </UiModal>
</template>
<script>
import UiModal from '@/components/ui/modal/ui-modal.vue';

export default {
    props: {
        unmatchCount: {
            type: Number,
            default: 0,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        UiModal,
    },
    data: () => ({}),
    methods: {
        illDoLater() {
            this.$cookies.set(
                'matchaccounts',
                '1',
                '14d',
                '/',
                window.location.hostname,
                true
            );
            this.$emit('close');
        },
        close() {
            this.$emit('close');
        },
    },
    mounted() {},
};
</script>
